var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"1rem","overflow":"hidden"}},[_c('TextScroll',{attrs:{"dataList":_vm.textArr,"isVis":_vm.isVis},on:{"handlerNotice":_vm.getAnnouncement}}),_c('WidgetsBrand')],1)}
var staticRenderFns = []

export { render, staticRenderFns }